import {UserState} from "./user-state";
import {Permissions} from "./permissions";
import {Workspace} from "../user-managment/workspace";
import {SignUpFor} from "../add-website/typeFormAnswers";

export class User {

  public id: string;
  public firstName: string;
  public lastName: string;
  public email: string;
  public password: string;
  public signUpFor: SignUpFor;
  public agencyOrFreelancer: boolean;
  public username: string;
  public phoneNumber: string;
  public timeZone: string;
  public timeZoneOffset: number;
  public companyName: string;
  public companyVat: string;
  public companyAddressLine1: string;
  public companyAddressLine2: string;
  public companyCountry: string;
  public companyCity: string;
  public companyState: string;
  public companyZipCode: string;
  public companyWebsite: string;
  public managerActivated: boolean;
  public createdAt: Date;

  public state: UserState;
  public permissions: Permissions;
  public planTitle: string;
  public planType: string;
  public apiResellerFree: boolean;
  public starterClient: boolean;
  public platformClient: boolean;
  public oneProductOrBundleClient: boolean;
  public category: string;
  public planProductSlug: string;
  public lastLogin: string;
  public hosting_services: any;
  public backup_services: any;
  public connectedFromProductId: number;
  public hasHostingTrial: boolean;
  public hostingTrialExpired: boolean;
  public hostingTrialExpirationDate: Date;
  public agreementDate: any;
  public additionalWebsiteCount: any;
  public twoFaStatus: boolean;
  public agreementId: any;
  public allowGrantAccess: boolean;
  public nps: boolean;
  public subscriptionId: any;
  public websiteCreated: any;
  public websiteConnected: any;
  public websiteConnectedSpeed: boolean;
  public emailVerified: boolean;
  public magicLinkSent: any;
  public planPrice: any;
  public set_source: any;
  public labels: string[];
  public hasExpertsProfile: boolean;
  public workspaces: Workspace[];
  public aiWebsiteConnected: number;
  public referralHash: string;
  public isSuspected: boolean;

  constructor() {}

}
